<div [formGroup]="formGroup">

  <div class="row mt-4">

    <!-- LEFT PANEL -->
    <div class="col-12 col-md-6">

      <h3 class="side-panel-label mb-2">Company Details</h3>

      <!-- Company Name -->
      <div class="mb-3">
        <label class="form-label">Name <sup>*</sup></label>
        <input
          type="text"
          class="form-control"
          formControlName="companyName"
          [ngClass]="{ 'is-invalid': f['companyName'].invalid && f['companyName'].touched }"
        />

        <app-validation
          field="companyName"
          [form]="formGroup"
          [error]="{
            required: 'Company name is required',
            minLength: 'Minimum 3 characters required',
            maxLength: 'Maximum 90 characters allowed',
            pattern: 'Only alphabets, numbers & spaces allowed'
          }"
        ></app-validation>
      </div>

      <!-- Display ID -->
      <div class="mb-3">
        <label class="form-label">Display Code <sup>*</sup></label>
        <input
          type="text"
          class="form-control"
          formControlName="companyDisplayId"
          [ngClass]="{ 'is-invalid': f['companyDisplayId'].invalid && f['companyDisplayId'].touched }"
        />

        <app-validation
          field="companyDisplayId"
          [form]="formGroup"
          [error]="{
            required: 'Display Code is required',
            minLength: 'Minimum 1 character required',
            maxLength: 'Maximum 8 characters allowed',
            pattern: 'Only alphabets, numbers & spaces allowed'
          }"
        ></app-validation>
      </div>

      <h4 class="side-panel-label mt-4 mb-2">Address</h4>

      <div class="row">

        <!-- Door No -->
        <div class="col-md-6 mb-3">
          <label class="form-label">Door No <sup>*</sup></label>
          <input
            type="text"
            class="form-control"
            formControlName="doorNo"
            [ngClass]="{ 'is-invalid': f['doorNo'].invalid && f['doorNo'].touched }"
          />

          <app-validation
            field="doorNo"
            [form]="formGroup"
            [error]="{
              required: 'Door number is mandatory',
              minLength: 'Minimum 1 character required',
              maxLength: 'Maximum 8 characters allowed',
              pattern: 'Only alphabets, numbers & spaces allowed'
            }"
          ></app-validation>
        </div>

        <!-- Street -->
        <div class="col-md-6 mb-3">
          <label class="form-label">Street Name <sup>*</sup></label>
          <input
            type="text"
            class="form-control"
            formControlName="street"
            [ngClass]="{ 'is-invalid': f['street'].invalid && f['street'].touched }"
          />

          <app-validation
            field="street"
            [form]="formGroup"
            [error]="{
              required: 'Street name is required',
              minLength: 'Minimum 3 characters required',
              maxLength: 'Maximum 90 characters allowed',
              pattern: 'Only alphabets, numbers & spaces allowed'
            }"
          ></app-validation>
        </div>

        <!-- Area (Optional) -->
        <div class="col-md-6 mb-3">
          <label class="form-label">Area</label>
          <input
            type="text"
            class="form-control"
            formControlName="area"
            [ngClass]="{ 'is-invalid': f['area'].invalid && f['area'].touched }"
          />

          <app-validation
            field="area"
            [form]="formGroup"
            [error]="{
              minLength: 'Minimum 3 characters required',
              maxLength: 'Maximum 90 characters allowed',
              pattern: 'Only alphabets, numbers & spaces allowed'
            }"
          ></app-validation>
        </div>

        <!-- City -->
        <div class="col-md-6 mb-3">
          <label class="form-label">City <sup>*</sup></label>
          <input
            type="text"
            class="form-control"
            formControlName="city"
            [ngClass]="{ 'is-invalid': f['city'].invalid && f['city'].touched }"
          />

          <app-validation
            field="city"
            [form]="formGroup"
            [error]="{
              required: 'City is mandatory',
              minLength: 'Minimum 1 character required',
              maxLength: 'Maximum 20 characters allowed',
              pattern: 'Only alphabets & spaces allowed'
            }"
          ></app-validation>
        </div>

        <!-- Pincode -->
        <div class="col-md-6 mb-3">
          <label class="form-label">Pincode <sup>*</sup></label>
          <input
            type="text"
            class="form-control"
            formControlName="pincode"
            [ngClass]="{ 'is-invalid': f['pincode'].invalid && f['pincode'].touched }"
          />

          <app-validation
            field="pincode"
            [form]="formGroup"
            [error]="{
              required: 'Pincode is required',
              minLength: 'Minimum 5 digits required',
              maxLength: 'Maximum 8 digits allowed',
              pattern: 'Only numbers allowed'
            }"
          ></app-validation>
        </div>

        <!-- State -->
        <div class="col-md-6 mb-3">
          <label class="form-label">State <sup>*</sup></label>
          <input
            type="text"
            class="form-control"
            formControlName="state"
            [ngClass]="{ 'is-invalid': f['state'].invalid && f['state'].touched }"
          />

          <app-validation
            field="state"
            [form]="formGroup"
            [error]="{
              required: 'State is mandatory',
              minLength: 'Minimum 2 characters required',
              maxLength: 'Maximum 15 characters allowed',
              pattern: 'Only alphabets & spaces allowed'
            }"
          ></app-validation>
        </div>

        <!-- Country -->
        <div class="col-md-6 col-12 mb-3">
          <label class="form-label">Country <sup>*</sup></label>
          <select
            class="form-select"
            formControlName="country"
            [ngClass]="{ 'is-invalid': f['country'].invalid && f['country'].touched }"
          >
            <option value="" disabled>Select Country</option>
            <option *ngFor="let c of countries" [value]="c.code">{{ c.name }}</option>
          </select>

          <app-validation
            field="country"
            [form]="formGroup"
            [error]="{
              required: 'Country selection is mandatory'
            }"
          ></app-validation>
        </div>

      </div>

    </div>

    <!-- RIGHT PANEL -->
    <div class="col-12 col-md-6 mt-4" *ngIf="showLogoUpload">
      <label class="form-label">Upload Logo <!--<sup>*</sup>--></label>

      <app-multiple-file-selector
        [maxAllowedSizeInMB]="2"
        [allowedTypes]="['image/png','image/jpeg']"
        (chooseFiles)="handleFileInput($event)"
        (removeFiles)="clearSelectedFiles($event)"
      ></app-multiple-file-selector>
    </div>

  </div>

  <!-- FOOTER BUTTONS -->
  <div class="d-flex justify-content-end mt-4 gap-2">
    <button class="btn btn-outline-danger" (click)="exit()">Exit</button>
    <button class="btn btn-primary" (click)="saveAndNext.emit()">Save & Next</button>
  </div>

</div>
